export const getCookie = (name) => {
  try {
    const cookie = document.cookie
      .split(";")
      .filter((el) => el.trim().startsWith(name))[0];
    if (cookie) {
      return cookie.split("=")[1];
    }
    return null;
  } catch (e) {
    console.warn(`Unable to get cookie - ${name}`, e);
    return null;
  }
};

export const setCookie = ({ key, value }) => {
  try {
    document.cookie = `${key}=${value}`;
  } catch (e) {
    console.warn("Unable to set cookie -", key);
  }
};

export const deleteCookie = (name) => {
  try {
    if (name) {
      document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    }
  } catch (e) {
    console.warn("Unable to delete cookie -", name, e);
  }
};

export const deleteAllCookies = () => {
  try {
    document.cookie.split(";").forEach((element) => {
      deleteCookie(element.split("=")[0]);
    });
  } catch (e) {
    console.warn("Unable to delete cookie -", e);
  }
};
